export default __webpack_public_path__ + "static/O0009-5f7770b45754f855ac913cac3d20d49d.png";